module.exports = __webpack_public_path__ + "static/media/cat_sneeuw.87154c9e.png";